<template>
  <div class="dropdown">
    <router-link class="item f16" :class="{ 'item--active': active }" :to="{ name: item.link }">
      <div class="item_icon">
        <BaseIcon :icon="item.icon" />
      </div>
      <div class="item_text">
        {{ item.text }}
        <svg
          v-if="item.childrens"
          class="arrow parent"
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 12L7 6.5L1 1"
            stroke="#2C2C2C"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </router-link>
    <slot></slot>
  </div>
</template>

<script>
// import IconsInterface from 'components/icons/interface/IconsInterface'

export default {
  name: 'InterfaceButtonsItem',
  props: ['item', 'active'],
  data() {
    return {
      hover: false,
    }
  },
  components: {
    // IconsInterface,
  },
}
</script>
<style lang="scss" scoped>
:deep().item {
  display: flex;
  align-items: center;
  padding: 14px 27px;
  column-gap: 16px;
  cursor: pointer;
  transition: 0.3s;
  color: #2c2c2c;
  text-decoration: none;
  background-color: #ffffff;
  position: relative;
  .arrow {
    transition: 0.3s;
    justify-self: flex-end;
  }
  &_icon {
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    svg {
      max-width: 20px;
      max-height: 20px;
      width: 100%;
      height: auto;
      path {
        fill: #52525f;
      }
    }
  }
  &_text {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    column-gap: 16px;
  }
  &--active {
    background: #277faf;
    color: #ffffff;
    .item_icon {
      svg {
        filter: brightness(0) invert(1);
      }
    }
    .arrow {
      filter: brightness(0) invert(1);
    }
  }
}
</style>
